import React from 'react';

interface Props {
    children: JSX.Element[] | JSX.Element | string;
}

const SubText: React.FC<Props> = ({ children }) => <div className="txt-sub">{children}</div>;

export default SubText;
